import Head from 'components/Head'
import PropertiesSearchBar from './PropertiesSearchBar'
import PropertiesList from './PropertiesList'
import Pagination from './Pagination'
import ReceiveNews from 'components/ReceiveNews'


export default function Imoveis({ data }) {
  return (
    <>
      <div className="container full">
        <div className="container-geral flex-column">
          <Head data={data.seo} />
          <PropertiesSearchBar />
          <PropertiesList />
          <Pagination />
        </div>
      </div>
        <ReceiveNews data={data.secaoRecebaNovidades} />
    </>
  )
}
